import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    overflow: scroll;
    ::-webkit-scrollbar {
      width: 0px;
    }
  `,
  card: css`
    &.MuiToggleButton-root {
      min-width: auto;
      text-transform: capitalize;
      height: 26px;
      margin: 5px;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border: 1px solid ${colors.prussianMid} !important;
      border-radius: 10px !important;
      cursor: pointer;
    }

    &.MuiToggleButton-root.Mui-selected {
      color: ${colors.prussian};
      font-weight: bold;
    }
  `,
  text: css`
    font-size: 14px;
    color: ${colors.prussian};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  logo: css`
    height: 18px;
    width: 18px;
    margin-right: 3px;
  `,
};

export default styles;
